// extracted by mini-css-extract-plugin
export default {"container":"nav_container__dmbR-","logo":"nav_logo__WATlW","connect":"nav_connect__8TXvd","account":"nav_account__oG1Q1","balance":"nav_balance__FiSIO"};